import React, { useState } from 'react'
import {
  CButton,
  CCol,
  CFormLabel,
  CFormTextarea,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react-pro'
import { banMounted } from './model'

type Props = {
  id: string
  isVisible: boolean
  onClose: () => void
  typeOfClient: string
}
export const BanModal: React.FC<Props> = ({
  isVisible,
  onClose,
  id,
  typeOfClient,
}) => {
  const [reason, setReason] = useState<string>('')

  const handleSubmit = () => {
    banMounted({
      id,
      typeOfClient,
      banReason: reason,
    })
    setReason('')
    onClose()
  }

  return (
    <CModal visible={isVisible} onClose={onClose} size={'lg'}>
      <CModalHeader>
        <CModalTitle>Set ban reason</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CRow>
          <CCol xs={9}>
            <div className="mb-4">
              <CFormLabel className="fw-bold">Enter a reason</CFormLabel>
              <CFormTextarea
                name="reason"
                placeholder="reason"
                value={reason}
                onChange={(e) => {
                  setReason(e.target.value)
                }}
              />
            </div>
          </CCol>
        </CRow>
      </CModalBody>
      <CModalFooter>
        <CButton
          color="secondary"
          onClick={() => {
            onClose()
            setReason('')
          }}
        >
          Cancel
        </CButton>
        <CButton color="primary" className="px-4" onClick={handleSubmit}>
          Ok
        </CButton>
      </CModalFooter>
    </CModal>
  )
}
